export function acceptLanguageHeader(language) {
  return language === 'fa' ? 'fa' : 'en';
}
